module.exports = __webpack_public_path__ + "nc_static/media/file_csv.bb223a20.svg";